import React, { Component } from 'react'
import { Heading, Price } from '@deseretbook/react-ui'

class ShipmentManifest extends Component {
  constructor(props) {
    super(props)

    this.createVariantMap = this.createVariantMap.bind(this)
    this.renderManifestItems = this.renderManifestItems.bind(this)

    this.state = {
      variantMap: this.createVariantMap(),
    }
  }

  createVariantMap() {
    const order = this.props.order
    const variantMap = {}

    order.lineItems.map((lineItem) => {
      variantMap[lineItem.variant.id] = lineItem.variant
    })

    return variantMap
  }

  renderManifestItems() {
    const shipment = this.props.shipment

    return shipment.manifest.map((item) => {
      const variant = this.state.variantMap[item.table.variant.id]

      return (
        <tr key={variant.id}>
          <td>{variant.name}</td>
          <td>{item.table.quantity}</td>
          <td>
            <Price value={variant.displayPrice} />
          </td>
        </tr>
      )
    })
  }

  render() {
    const shipment = this.props.shipment

    return (
      <div>
        <Heading>Shipping Manifest - {shipment.number}</Heading>
        <div className="table-responsive">
          <table className="table">
            <colgroup>
              <col style={{ width: '60%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
            </colgroup>

            <thead>
              <tr>
                <th>Name</th>
                <th>Qty</th>
                <th>Price</th>
              </tr>
            </thead>

            <tbody>{this.renderManifestItems()}</tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default ShipmentManifest
